module.exports = "<input class=\"tab\" type=\"radio\" name=\"tabs\" [attr.checked]=\"tabIndex === 0 ? true : null\" [attr.id]=\"'filter-tab-' + tabIndex\" (click)=\"onFilterTabChanged($event, tabIndex, tabName)\">\r\n<label [attr.for]=\"'filter-tab-' + tabIndex\" class=\"tab-label\">\r\n    <label [attr.for]=\"'checkbox-tab-' + tabIndex\"></label>\r\n    {{ tabName }}\r\n</label>"


//////////////////
// WEBPACK FOOTER
// ./src/app/filter_panel/filter_tab.component.html
// module id = 551
// module chunks = 1